import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------ English ------------------------------ */
i18next.addResources(locales.EN, 'DIVORCES_SHOW', {
  TITLE: 'Divorce Information',
  MARRIAGE: 'Marriage',
  HUSBAND: 'Husband',
  WIFE: 'Wife',
  DOCUMENTS: 'Documents',
  COMMENTS: 'Comments',
  MARRIAGE_INFORMATION: 'Marriage information',
  HUSBAND_INFORMATION: 'Husband information',
  WIFE_INFORMATION: 'Wife information',
  DOCUMENTS_INFORMATION: 'Documents information',
  WEDDING_TEMPLE: 'Temple where the parents were married',
  WEDDING_DATE: 'Jupa wedding date',
  FIRST_NAME: 'First names',
  LAST_NAME: 'Last names',
  EMAIL: 'Email',
  ID_CARD_TYPE: 'ID Card type',
  ID_CARD: 'ID card',
  ID_CARD_FILE: 'ID card file',
  ID_CARD_BACK_FILE: 'ID card back file',
  KETUBA_FILE: 'Ketuba file',
  MARRIAGE_CERTIFICATE_FILE: 'Marriage certificate file',
  DIVORCE_CERTIFICATE_FILE: 'Divorce certificate file',
  AREA_CODE: 'Area code',
  PHONE: 'Phone',
  ADDRESS: 'Address',
  APARTMENT: 'Floor/Apartment',
  LOCALITY: 'locality',
  FILES: 'Files',
  LOADING: 'Loading...',
  PROVINCE: 'Province',
  COUNTRY: 'Country',
});

/* ------------------------------ Spanish ------------------------------ */
i18next.addResources(locales.ES, 'DIVORCES_SHOW', {
  TITLE: 'Información del divorcio',
  MARRIAGE: 'Matrimonio',
  HUSBAND: 'Esposo',
  WIFE: 'Esposa',
  DOCUMENTS: 'Documentos',
  COMMENTS: 'Observaciones',
  MARRIAGE_INFORMATION: 'Información del matrimonio',
  HUSBAND_INFORMATION: 'Información del esposo',
  WIFE_INFORMATION: 'Información de la esposa',
  DOCUMENTS_INFORMATION: 'Información de los documents',
  WEDDING_TEMPLE: 'Templo donde se casaron (por jupá)',
  WEDDING_DATE: 'Fecha de casamiento',
  FIRST_NAME: 'Nombres',
  LAST_NAME: 'Apellidos',
  EMAIL: 'Email',
  ID_CARD_TYPE: 'Tipo de documento',
  ID_CARD: 'Documento',
  ID_CARD_FILE: 'Documento de identidad (escaneado)',
  ID_CARD_BACK_FILE: 'Documento dorso (escaneado)',
  KETUBA_FILE: 'Ketubá',
  MARRIAGE_CERTIFICATE_FILE: 'Libreta de casamiento',
  DIVORCE_CERTIFICATE_FILE: 'Certificado de divorcio',
  AREA_CODE: 'Código de área',
  PHONE: 'Celular',
  ADDRESS: 'Domicilio',
  APARTMENT: 'Piso/Departamento',
  LOCALITY: 'Localidad',
  FILES: 'Archivos',
  LOADING: 'Cargando...',
  PROVINCE: 'Provincia',
  COUNTRY: 'País',
});
